export function StyledTargetSourceRenderer(params: {
  value?: { target?: string; source?: string };
  data?: any;
}) {
  if (!params.value) {
    return '<span style="color: #999;">-</span>';
  }

  const { target, source } = params.value;
  const dialectCode = params.data?.dialect_code || 'XX';

  let html = '<div style="padding: 4px 0;">';

  // Target is EN translation
  if (target) {
    html += `
      <div style="
        padding: 6px 10px;
        background-color: #f5f5f5;
        border-left: 3px solid #2196f3;
        border-radius: 3px;
        margin-bottom: 6px;
        line-height: 1.4;
      ">
        <strong>EN:</strong> ${target}
      </div>
    `;
  }

  // Source is the dialect translation
  if (source) {
    html += `
      <div style="
        padding: 6px 10px;
        background-color: #f5f5f5;
        border-left: 3px solid #4caf50;
        border-radius: 3px;
        line-height: 1.4;
      ">
        <strong>${dialectCode}:</strong> ${source}
      </div>
    `;
  }

  html += '</div>';
  return html;
}
